import styled from 'styled-components'
import { getCalendarHeaderStyles } from '../style'
import { getMonthNavButtonStyles } from '../style'

const StyledCalendarHeader = styled.div`
    ${getCalendarHeaderStyles}
`

export const StyledMonthNavButton = styled.button`
    ${getMonthNavButtonStyles}
`

export default StyledCalendarHeader
